<template>
  <common-dialog ref="dialog" :title="title" width="1200px" :in-dialog="inDialog">
    <el-container>
      <type-tree ref="typeTree" :is-edit="false" @on-select="onTreeSelect"></type-tree>
      <el-main class="my-main" style="padding-bottom: 0;">
        <list ref="list" :show-checkbox="multiple" :checkbox-fixed="false" :show-status="false">
          <template #column>
            <slot name="column" />
            <template v-if="selectable&&!multiple">
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{row}">
                  <el-button @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
      </el-main>
    </el-container>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
import typeTree from "@/components/goods/info/typeTree";

export default {
  components: { commonDialog, list, typeTree },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "商品规格型号列表",
    },
  },
  data() {
    return {
      data: {
        IdChain: "",
        ClassName: "",
      },
      params: {},
    };
  },
  methods: {
    getTree() {
      this.$refs.typeTree.getData();
    },
    getData(params) {
      this.params = { ...params };
      this.$refs.list.getData(this.params);
    },
    onTreeSelect(data) {
      if (this.data.IdChain != data.IdChain) {
        this.data.IdChain = data.IdChain;
        this.data.ClassName = data.ClassName;
        this.$refs.list.getData({ ...this.params, TypeIdChain: data.IdChain });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.my-aside {
  margin-top: 20px;
}
</style>